import React, { useState, useEffect } from "react";
import { array, string } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import { get } from "lodash";
import { parseUrl } from "query-string";

import "./footerMenuGroup.m.css";

const FooterMenuGroup = ({ links, className = "", currentPath, sketchesHost }) => {
  const [location, setLocation] = useState(sketchesHost);

  useEffect(() => {
    setLocation(global.location.origin);
  }, []);

  const constructHref = (url) => {
    const params = parseUrl(currentPath);
    const redirectUrl = get(params, ["query", "callback-url"], location);

    return `${redirectUrl}${url}`;
  };

  return (
    <div styleName="wrapper" className={`footer-menu-group ${className}`}>
      {links.map((item, index) => {
        if (item["item-type"] === "placeholder") {
          return (
            <span key={index} styleName="footer-menu-item" className="footer-list-menu-item">
              {item.title}
            </span>
          );
        } else if (item["item-type"] === "tag" || item["item-type"] === "entity") {
          const slugType = `${item["item-type"]}-slug`;
          const destUrl = `/topic/${item[slugType]}`;
          return (
            <Link
              aria-label={item.title}
              href={constructHref(destUrl)}
              key={index}
              styleName="footer-menu-item"
              className="footer-list-menu-item"
            >
              {item.title}
            </Link>
          );
        } else {
          return (
            <Link
              aria-label={item.title}
              href={item.completeUrl}
              key={index}
              styleName="footer-menu-item"
              className="footer-list-menu-item"
              disableAjaxLinks={true}
            >
              {item.title}
            </Link>
          );
        }
      })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  currentPath: get(state, ["qt", "currentPath"], ""),
  domainSlug: get(state, ["qt", "domainSlug"]),
  sketchesHost: get(state, ["qt", "config", "sketches-host"], "https://www.prothomalo.com"),
});

FooterMenuGroup.propTypes = {
  links: array,
  className: string,
  currentPath: string,
  domainSlug: string,
  sketchesHost: string,
  sections: array,
};

export default connect(mapStateToProps, null)(FooterMenuGroup);
